import { useLocation } from 'react-router-dom'
import Logov from '../../assets/images/logo-new-v.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faLinkedin,
  faGithub,
  faInstagram,
  faStackOverflow,
} from '@fortawesome/free-brands-svg-icons'
import {
  faHome,
  faUser,
  faEnvelope,
  faSuitcase,
  faProjectDiagram,
  faFile,
  faRobot,
} from '@fortawesome/free-solid-svg-icons'
import { Link, NavLink } from 'react-router-dom'
import profile from '../../data/profiles/activeProfile'
import './index.scss'

const { contact } = profile

const navLinks = [
  { to: '/',           icon: faHome,           label: 'Home',       exact: true },
  { to: '/about',      icon: faUser,           label: 'About',      className: 'about-link' },
  { to: '/experience', icon: faSuitcase,       label: 'Exp',        className: 'portfolio-link' },
  { to: '/resume',     icon: faFile,           label: 'Resume',     className: 'resume-link' },
  { to: '/projects',   icon: faProjectDiagram, label: 'Projects',   className: 'projects-link' },
  { to: '/contact',    icon: faEnvelope,       label: 'Contact',    className: 'contact-link' },
  { to: '/ai',         icon: faRobot,          label: 'AI',         className: 'ai-link' },
]

const Sidebar = () => {
  const location = useLocation()

  const activeIndex = Math.max(
    0,
    navLinks.findIndex(({ to }) =>
      to === '/' ? location.pathname === '/' : location.pathname.startsWith(to)
    )
  )

  // Bubble left: center of active slot as a percentage
  const slotWidth = 100 / navLinks.length
  const bubbleLeft = `${activeIndex * slotWidth + slotWidth / 2}%`

  return (
    <>
      {/* ── Desktop sidebar ── */}
      <div className="nav-bar">
        <Link className="logo" to="/">
          <img src={Logov} alt="Logo" />
        </Link>

        <nav>
          {navLinks.map(({ to, icon, label, className, exact }) => (
            <NavLink
              key={to}
              to={to}
              end={exact}
              title={label}
              className={({ isActive }) =>
                [className, isActive ? 'active' : ''].filter(Boolean).join(' ')
              }
            >
              <FontAwesomeIcon icon={icon} />
              <span className="nav-tooltip">{label}</span>
            </NavLink>
          ))}
        </nav>

        <ul>
          <li>
            <a href={contact.linkedin.url} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faLinkedin} className="anchor-icon" />
            </a>
          </li>
          <li>
            <a href={contact.github.url} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faGithub} className="anchor-icon" />
            </a>
          </li>
          <li>
            <a href={contact.instagram} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faInstagram} className="anchor-icon" />
            </a>
          </li>
          <li>
            <a href={contact.stackoverflow} target="_blank" rel="noreferrer">
              <FontAwesomeIcon icon={faStackOverflow} className="anchor-icon" />
            </a>
          </li>
        </ul>
      </div>

      {/* ── Mobile top bar ── */}
      {/* <div className="mobile-top-bar">
        <Link to="/">
          <img src={Logov} alt="Logo" />
        </Link>
      </div> */}

      {/* ── Mobile magic bottom nav ── */}
      <nav className="mobile-bottom-nav" aria-label="Main navigation">
        {/* Sliding bubble — shows active icon above the bar */}
        <div className="nav-bubble" style={{ left: bubbleLeft }}>
          <FontAwesomeIcon icon={navLinks[activeIndex].icon} />
          <span className="bubble-label">{navLinks[activeIndex].label}</span>
        </div>

        {navLinks.map(({ to, icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              ['mobile-nav-item', isActive ? 'active' : ''].filter(Boolean).join(' ')
            }
            aria-label={label}
          >
            <span className="nav-item-icon">
              <FontAwesomeIcon icon={icon} />
            </span>
          </NavLink>
        ))}
      </nav>
    </>
  )
}

export default Sidebar
